import CollectionView from './base';
import Marker from '../views/marker';

export default CollectionView.extend( {
	modelView: Marker,

	_createElement: function() {
		// do nothing
	},

	_setElement: function( el ) {
		this.el = el;
	},

	_setAttributes: function() {
		// do nothing
	},

	initialize: function() {
		CollectionView.prototype.initialize.apply( this, arguments );

		this.childOptions.map = this.el;
	},

	findElements: function() {},

	insertChild: function() {},

	sortChildren: function() {},

	render: function() {
		this.resetChildren();
		return this;
	},

	resetChildren: function() {
		this.callEach( 'remove' );
		this.collection.each( model => this.addChild( model ) );

		return this;
	},

	renderStatus: function() {},
} );
